export const goToFooterContacts = (locationId) => {
    document.getElementById(locationId).scrollIntoView({
        behavior: "smooth"
    })
}

export const goToGetInTouchForm = (locationId) => {
    setTimeout( () => {document.getElementById(locationId).scrollIntoView({ behavior: 'smooth'});}, 300);
}
